import "./App.css";
import React from "react";
import { ToastContainer } from "react-toastify";
import NavBar from "./components/navBar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import Home from "./views/Home";
import FormularioCadastro from "./views/FormularioCadastro";
import FormularioEnviado from "./views/FormularioEnviado";
import Login from "./views/Login";
import Gerenciamento from "./views/Gerenciamento";
import authService from "./services/authService";
import httpService from "./services/httpService";
import { SplashView } from "./views/splash";
import { Modal } from "./components/Modal";
import { ChangePassword } from "./views/ChangePassword";

registerLocale("pt", pt);
setDefaultLocale("pt");

//const Home = React.lazy(() => import("./views/Home"));
//const FormularioCadastro = React.lazy(() => import("./views/FormularioCadastro"));
//const FormularioEnviado = React.lazy(() => import("./views/FormularioEnviado"));
// const Login = React.lazy(() => import("./views/Login"));
//const Gerenciamento = React.lazy(() => import("./views/Gerenciamento"));

// const loading = () => (
//   <div className="animated fadeIn pt-3 text-center">
//     <i className="fa fa-spinner fa-spin" /> {"Carregando"}
//   </div>
// );

function App() {

  const jwt = authService.getJwt();
  if (jwt)
    httpService.setJwt(jwt);

  return (
    
      <React.Fragment>
        <ToastContainer hideProgressBar={true}></ToastContainer>
        <Modal />
        <NavBar></NavBar>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SplashView />} ></Route>
            <Route path="/home" element={<Home />} ></Route>
            <Route path="/formularioEnviado" element={<FormularioEnviado />}></Route>
            <Route path="/cadastro" element={<FormularioCadastro />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/gerenciamento/*" element={<Gerenciamento />}></Route>
            <Route path="/changePassword" element={<ChangePassword />} ></Route>

          </Routes>
        </BrowserRouter>
      </React.Fragment>
  );
}

export default App;
